import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { Home, STATUS_ENVIADA } from '../../../core/models/requerimento';
import { LoaderService } from '../../../shared/services/loader-service';
import { RequerimentoService } from '../../../shared/services/requerimento-service';
import { RequerimentoState } from '../../../shared/services/requerimento-state';
import { ROTA_PAGINA_INDISPONIVEL, rotaDoErroRequerimento } from '../../../shared/utils/requerimento-erros';
import { MOTIVOS_NAO_ELEGIVEL_STATE } from '../../token-invalido/token-invalido';
/**
 * Busca o GET /v1/requerimentos/home antes de ativar a HomeRequerimento, sem carregá-la quando a pessoa não segue:
 * não elegível (N) vai para o token inválido com os motivos, e requerimento já enviado e ainda aberto (STATUS_ENVIADA)
 * vai para os detalhes. Nos demais casos, a home chega ao componente em `data.home`.
 */
export const homeRequerimentoResolver: ResolveFn<Home> = async () => {
  const router = inject(Router);
  const loaderService = inject(LoaderService);
  const requerimentoService = inject(RequerimentoService);
  const requerimentoState = inject(RequerimentoState);

  loaderService.showLoader('Carregando...');
  try {
    const home = await requerimentoService.getHome();
    // Os dados cadastrais (etapa 1) exibem o participante da home sem buscá-la de novo.
    requerimentoState.definirHome(home);

    // Não elegível (N) não acessa o fluxo: vai para o token inválido com os motivos. Com restrições (R) segue como E.
    if (home.elegibilidade.tipo === 'N') {
      return new RedirectCommand(router.parseUrl('/token-invalido'), {
        replaceUrl: true,
        state: { [MOTIVOS_NAO_ELEGIVEL_STATE]: home.elegibilidade.motivos },
      });
    }

    const emAndamento = home.requerimentoEmAndamento;
    if (emAndamento) {
      requerimentoState.definir(emAndamento);
      if (STATUS_ENVIADA.includes(emAndamento.status)) {
        return new RedirectCommand(router.parseUrl('/requerimento-beneficio/detalhes'), { replaceUrl: true });
      }
    } else {
      // Sem requerimento aberto: descarta um id antigo guardado, para os dados cadastrais abrirem um novo.
      requerimentoState.limpar();
    }
    return home;
  } catch (erro) {
    return new RedirectCommand(router.parseUrl(rotaDoErroRequerimento(erro) ?? ROTA_PAGINA_INDISPONIVEL));
  } finally {
    loaderService.hideLoader();
  }
};
